import React from 'react';
import CPPUtils from 'services/CPPUtils';
import Icon from 'components/Utils/NewIcon';
import { setFormValues } from 'hooks/useReduxForm';
import { useAppDispatch } from 'careand-redux/useAppDispatch';

const ACTIVE_TAB = 'administered_drugs';

interface CPPTimelineAdministeredDrugProps {
  drug: any;
  patient: any;
  onClick?: () => void;
  setActiveCPPTab: (tab: string) => void;
}

const CPPTimelineAdministeredDrug = ({
  drug,
  patient,
  onClick,
  setActiveCPPTab,
}: CPPTimelineAdministeredDrugProps) => {
  const dispatch = useAppDispatch();

  function editCPPItem() {
    let data = drug.value;
    setActiveCPPTab(ACTIVE_TAB);
    const formName = CPPUtils.getFormName(ACTIVE_TAB, patient.id);
    dispatch(setFormValues({ formName, values: { ...data, itemId: drug.id } }));
  }

  return (
    <div className="item-wrapper clickable" data-tip data-for={drug.id} onClick={editCPPItem}>
      <div className="top-bar">
        <Icon src="syringe" />
        <span className="small-title">Med Administration</span>
      </div>
      <div className="item-content">
        <span>{CPPUtils.getImmunizationDescription(drug.value)}</span>
      </div>
    </div>
  );
};

export default CPPTimelineAdministeredDrug;
